function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "065---Levels",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m54 59h-50c4.72 0 5.9-7.66 8-19.99 1.467-8.623 2.831-19.083 8-25.81 4.225-5.656 9.751-6.349 14-3.76 3.824 2.294 6.444 7.151 8 11.39 1.743 4.7 2.534 9.564 4 18.18 2.1 12.33 3.28 19.99 8 19.99z",
  fill: "#f0c419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m30 8.06v50.94h-2v-50.94c.6642665-.08000321 1.3357335-.08000321 2 0z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m26 8.5v50.5h-2v-49.56c.6282127-.38936318 1.299335-.70479066 2-.94z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m22 10.97v48.03h-2v-45.8c.5955052-.8042075 1.2651023-1.5508082 2-2.23z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m18 16.34v42.66h-2v-38.17c.5614545-1.5413499 1.2297431-3.0416578 2-4.49z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m14 28v31h-2v-19.99c.57-3.35 1.21-7.04 2-11.01z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m46 39.01v19.99h-2v-31c.79 3.97 1.43 7.66 2 11.01z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m42 20.83v38.17h-2v-42.66c.7702569 1.4483422 1.4385455 2.9486501 2 4.49z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m38 13.2v45.8h-2v-48.03c.7348977.6791918 1.4044948 1.4257925 2 2.23z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m34 9.44v49.56h-2v-50.5c.700665.23520934 1.3717873.55063682 2 .94z",
  fill: "#f29c1f"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#2c3e50"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 54h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 50h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 46h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 42h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 38h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 34h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 30h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 26h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 22h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 18h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 14h-2c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h2c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 10h-2c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1h2c.55228475 0 1 .44771525 1 1s-.44771525 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m3 6h-2c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1h2c.55228475 0 1 .44771525 1 1s-.44771525 1-1 1z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "m59 60h-57c-1.1045695 0-2-.8954305-2-2v-57c0-.55228475.44771525-1 1-1s1 .44771525 1 1v57h57c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z",
  fill: "#35495e"
})));

var SvgLightlevel = function SvgLightlevel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightlevel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightlevel.3455ca6c.svg";
export { ForwardRef as ReactComponent };